webpackJsonp([2],{

/***/ 183:
/***/ (function(module, exports) {

/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
  var defaults = {
    url: false,
    callback: false,
    target: false,
    duration: 120,
    on: 'mouseover',
    // other options: grab, click, toggle, click-n-grab
    touch: true,
    // enables a touch fallback
    onZoomIn: false,
    onZoomOut: false,
    magnify: 1,
    moveDirection: 'standard' // NEW: 'standard' (default) or 'reverse'
  };

  // Core Zoom Logic, independent of event listeners.
  $.zoom = function (target, source, img, magnify, settings) {
    var targetHeight,
      targetWidth,
      sourceHeight,
      sourceWidth,
      xRatio,
      yRatio,
      offset,
      $target = $(target),
      position = $target.css('position'),
      $source = $(source);

    // The parent element needs positioning so that the zoomed element can be correctly positioned within.
    target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
    target.style.overflow = 'hidden';
    img.style.width = img.style.height = '';
    $(img).addClass('zoomImg').css({
      position: 'absolute',
      top: 0,
      left: 0,
      opacity: 0,
      width: img.width * magnify,
      height: img.height * magnify,
      border: 'none',
      maxWidth: 'none',
      maxHeight: 'none'
    }).appendTo(target);
    return {
      init: function init() {
        targetWidth = $target.outerWidth();
        targetHeight = $target.outerHeight();
        if (source === target) {
          sourceWidth = targetWidth;
          sourceHeight = targetHeight;
        } else {
          sourceWidth = $source.outerWidth();
          sourceHeight = $source.outerHeight();
        }
        xRatio = (img.width - targetWidth) / sourceWidth;
        yRatio = (img.height - targetHeight) / sourceHeight;
        offset = $source.offset();
      },
      move: function move(e) {
        var left = e.pageX - offset.left,
          top = e.pageY - offset.top;
        top = Math.max(Math.min(top, sourceHeight), 0);
        left = Math.max(Math.min(left, sourceWidth), 0);
        img.style.left = left * -xRatio + 'px';
        img.style.top = top * -yRatio + 'px';
      }
    };
  };
  $.fn.zoom = function (options) {
    return this.each(function () {
      var settings = $.extend({}, defaults, options || {}),
        //target will display the zoomed image
        target = settings.target && $(settings.target)[0] || this,
        //source will provide zoom location info (thumbnail)
        source = this,
        $source = $(source),
        img = document.createElement('img'),
        $img = $(img),
        mousemove = 'mousemove.zoom',
        clicked = false,
        touched = false;

      // If a url wasn't specified, look for an image element.
      if (!settings.url) {
        var srcElement = source.querySelector('img');
        if (srcElement) {
          settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
        }
        if (!settings.url) {
          return;
        }
      }
      $source.one('zoom.destroy', function (position, overflow) {
        $source.off(".zoom");
        target.style.position = position;
        target.style.overflow = overflow;
        img.onload = null;
        $img.remove();
      }.bind(this, target.style.position, target.style.overflow));
      img.onload = function () {
        // Modified: Pass 'settings' as the new fifth argument to $.zoom
        var zoom = $.zoom(target, source, img, settings.magnify, settings);
        function start(e) {
          zoom.init();
          zoom.move(e);

          // Skip the fade-in for IE8 and lower since it chokes on fading-in
          // and changing position based on mousemovement at the same time.
          $img.stop().fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
        }
        function stop() {
          $img.stop().fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
        }

        // Mouse events
        if (settings.on === 'grab') {
          $source.on('mousedown.zoom', function (e) {
            if (e.which === 1) {
              $(document).one('mouseup.zoom', function () {
                stop();
                $(document).off(mousemove, zoom.move);
              });
              start(e);
              $(document).on(mousemove, zoom.move);
              e.preventDefault();
            }
          });
        } else if (settings.on === 'click') {
          $source.on('click.zoom', function (e) {
            if (clicked) {
              // bubble the event up to the document to trigger the unbind.
              return;
            } else {
              clicked = true;
              start(e);
              $(document).on(mousemove, zoom.move);
              $(document).one('click.zoom', function () {
                stop();
                clicked = false;
                $(document).off(mousemove, zoom.move);
              });
              return false;
            }
          });
        } else if (settings.on === 'toggle') {
          $source.on('click.zoom', function (e) {
            if (clicked) {
              stop();
            } else {
              start(e);
            }
            clicked = !clicked;
          });
        } else if (settings.on === 'mouseover') {
          zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

          $source.on('mouseenter.zoom', start).on('mouseleave.zoom', stop).on(mousemove, zoom.move);
        } else if (settings.on === 'click-n-grab') {
          // NEW: Custom 'click-n-grab' behavior

          var isMouseDown = false;
          var startX, startY;
          var isDragging = false; // Flag to track if a drag occurred during the current mouse interaction
          var DRAG_THRESHOLD = 5; // Pixels to consider it a drag

          // Variables for persistent dragging in 'reverse' mode for 'click-n-grab'
          var lastMouseX = 0;
          var lastMouseY = 0;
          var currentImgLeft = 0; // Stores the image's left position at the start of a drag segment
          var currentImgTop = 0; // Stores the image's top position at the start of a drag segment

          $source.on('mousedown.zoom', function (e) {
            if (e.which === 1) {
              // Only left mouse button
              isMouseDown = true;
              startX = e.pageX;
              startY = e.pageY;
              isDragging = false; // Reset drag flag for this new interaction

              // Capture current image position and mouse position at the start of any potential drag
              // This is crucial for 'reverse' mode to continue from the current position
              currentImgLeft = parseFloat(img.style.left) || 0;
              currentImgTop = parseFloat(img.style.top) || 0;
              lastMouseX = e.pageX;
              lastMouseY = e.pageY;

              // Attach mousemove listener to the document for dragging
              $(document).on(mousemove, function (moveEvent) {
                if (isMouseDown) {
                  // Only process if mouse button is still down
                  // Check if movement exceeds threshold to be considered a drag
                  if (!isDragging && (Math.abs(moveEvent.pageX - startX) > DRAG_THRESHOLD || Math.abs(moveEvent.pageY - startY) > DRAG_THRESHOLD)) {
                    isDragging = true;
                    // If a drag is detected and not yet zoomed, initiate zoom here
                    if (!clicked) {
                      start(moveEvent); // Start zoom when drag is detected
                      clicked = true;
                    }
                  }
                  if (clicked) {
                    // Only move the image if it's currently zoomed
                    // zoom.move(moveEvent);
                    if (settings.moveDirection === 'reverse') {
                      var deltaX = moveEvent.pageX - lastMouseX;
                      var deltaY = moveEvent.pageY - lastMouseY;
                      var newLeft = currentImgLeft + deltaX;
                      var newTop = currentImgTop + deltaY;
                      var currentTargetWidth = $(target).outerWidth();
                      var currentTargetHeight = $(target).outerHeight();
                      ;
                      var minLeft = -(img.width - currentTargetWidth);
                      var maxLeft = 0;
                      var minTop = -(img.height - currentTargetHeight);
                      var maxTop = 0;

                      // Ensure the image doesn't move out of bounds
                      newLeft = Math.max(minLeft, Math.min(newLeft, maxLeft));
                      newTop = Math.max(minTop, Math.min(newTop, maxTop));
                      img.style.left = newLeft + 'px';
                      img.style.top = newTop + 'px';

                      // Update currentImgLeft/Top and lastMouseX/Y for the next delta calculation
                      currentImgLeft = newLeft;
                      currentImgTop = newTop;
                      lastMouseX = moveEvent.pageX;
                      lastMouseY = moveEvent.pageY;
                    } else {
                      zoom.move(moveEvent);
                    }
                  }
                }
              });
              e.preventDefault(); // Prevent default browser drag behavior
            }
          });
          $(document).on('mouseup.zoom', function (e) {
            if (isMouseDown) {
              // If mouse button was down from our mousedown event
              isMouseDown = false; // Mouse button released
              $(document).off(mousemove); // Detach mousemove listener
              // If it was a click (no drag occurred during this interaction)
              if (!isDragging) {
                if (clicked) {
                  // If currently zoomed, this click resets the zoom
                  stop(); // Reset zoom
                  clicked = false; // Mark as zoomed out
                } else {
                  // If not zoomed, this click initiates the zoom
                  start(e);
                  clicked = true; // Mark as zoomed in
                }
              }
              // If it was a drag (`isDragging` is true), the `clicked` state
              // (which would be true from `mousemove`) is maintained.
              // No change to `clicked` state on mouseup after a drag.
            }
          });
        }

        // Touch fallback
        if (settings.touch) {
          $source.on('touchstart.zoom', function (e) {
            e.preventDefault();
            if (touched) {
              touched = false;
              stop();
            } else {
              touched = true;
              start(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
            }
          }).on('touchmove.zoom', function (e) {
            e.preventDefault();
            zoom.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]);
          }).on('touchend.zoom', function (e) {
            e.preventDefault();
            if (touched) {
              touched = false;
              stop();
            }
          });
        }
        if ($.isFunction(settings.callback)) {
          settings.callback.call(img);
        }
      };
      img.setAttribute('role', 'presentation');
      img.alt = '';
      img.src = settings.url;
    });
  };
  $.fn.zoom.defaults = defaults;
})(window.jQuery);

/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_bis_and_so__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_to_bag__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_wishlist__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_lazy_plugins_jquery_lazy_ajax__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_lazy_plugins_jquery_lazy_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery_lazy_plugins_jquery_lazy_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jquery_zoom__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jquery_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__jquery_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styleguide_modules_slides__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styleguide_src_assets_modules_slick_custom_paging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_psykhe__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_social_proof__ = __webpack_require__(18);











function showSizeGuidePopup() {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    "measurements": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("measurements"),
    "measuretable": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("measuretable"),
    "international": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("international"),
    "bullets": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("bullets")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("url"),
    data: data,
    triggerOpen: true,
    closeButton: true,
    returnFocus: '#size_and_fit_link',
    onComplete: function onComplete() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close_btn').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__content').focus();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeguide_measurement").click(convertSize);
    }
  });
}
function showBisPopup(element) {
  var link = element.data("url");
  var elementSelector = '#' + element.attr('id');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: link,
    triggerOpen: true,
    triggerElement: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element),
    closeButton: true,
    type: 'small',
    returnFocus: elementSelector,
    onComplete: __WEBPACK_IMPORTED_MODULE_1__modules_bis_and_so__["a" /* default */]
  });
}
function convertSize() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeguide_measurement").removeClass("active");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("active");
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text() == "IN") {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertInch").show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertCM").hide();
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertCM").show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertInch").hide();
  }
}
function getWishListSelectedSize() {
  var size = '';
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-size-div:visible").length > 0 || __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product_info").data("onesize")) {
    size = 'all';
  } else {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select option:selected").val())) {
      size = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select option:selected").val());
    }
  }
  return size;
}
function submitNotifyMe(code, size, email, callback) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    size: size,
    email: email,
    code: code,
    fw: true
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function (msg) {
    if (callback) {
      callback();
    }
  });
}
function validateEmail(emailStr) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(emailStr);
}

// NOTE: must match java functions ([^a-zA-Z0-9])
function getHTMLJSSaveId(value) {
  return value.replace(/[\W_]+/g, "");
}
function bindEditorPickEvent() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-editor-pick-modal').on('click', function (e) {
    e.preventDefault();
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var productCode = $el.data('productCode');
    var lookIndex = $el.data('lookIndex');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: $el.data('modalUrl'),
      data: {
        code: productCode,
        index: lookIndex
      },
      type: 'large',
      triggerOpen: true,
      addModifierClass: 'modal--lg-height',
      onComplete: function onComplete() {
        bindEditorPickProductLazy();
        bindEditorPickAddToBagEvent();
        bindEditorPickPdpEvent();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-editor-pick-carousel').each(function (i, item) {
          var $item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item);
          var $slickSlides = $item.find('.js-slides-slick');
          $item.slides({
            arrows: true
          });
          $slickSlides.slick('slickGoTo', lookIndex);
          $slickSlides.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            var $productsContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#editor-pick-products-content');
            var $loader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#editor-pick-progress-bar');
            $productsContent.addClass('u-hide');
            $loader.find('.progress-bar').css('left', '75%');
            $loader.removeClass('u-hide');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
              url: $item.data('productsUrl'),
              data: {
                code: productCode,
                index: nextSlide
              },
              success: function success(data) {
                $productsContent.html(data);
                bindEditorPickProductLazy();
                bindEditorPickAddToBagEvent();
                bindEditorPickPdpEvent();
                $productsContent.removeClass('u-hide');
                $loader.addClass('u-hide');
                $loader.find('.progress-bar').removeAttr('style');
              }
            });
          });
        });
      }
    });
    if (typeof logEngagement === 'function') {
      logEngagement(window.location.href, 'editors picks', 'open');
    }
  });
}
function bindEditorPickPdpEvent() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal-editorial-pdp').on('click', function (e) {
    e.preventDefault();
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $editorPickContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#editor-pick-content');
    var $loader = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#editor-pick-progress-bar');
    $editorPickContent.addClass('u-hide');
    $loader.removeClass('u-hide');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: $el.data('url'),
      data: {
        productCode: $el.data('code')
      },
      success: function success(data) {
        var $pdpContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#editor-pick-pdp-content');
        $pdpContent.html(data);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-editor-product-carousel').each(function (i, item) {
          var $item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item);
          $item.slides({
            arrows: true
          });
        });
        bindEditorPickAddToBagEvent();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#back-button').on('click', function () {
          $pdpContent.addClass('u-hide');
          $editorPickContent.removeClass('u-hide');
          if (typeof logEngagement === 'function') {
            logEngagement(window.location.href, 'editors picks', 'back to editors picks');
          }
        });
        $pdpContent.removeClass('u-hide');
        $loader.addClass('u-hide');
      }
    });
    if (typeof logEngagement === 'function') {
      logEngagement(window.location.href, 'editors picks', 'view more details');
    }
  });
}
function bindEditorPickProductLazy() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-editor-product-lazy').lazy({
    threshold: 2000,
    throttle: 25
  });
}
function bindEditorPickAddToBagEvent() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-editor-add-to-bag').on('click', function (e) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $sizeSelect = $el.data('index') ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sizeSelect".concat($el.data('index'))) : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeSelect');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__add_to_bag__["a" /* default */])($el.data('code'), $sizeSelect.length ? $sizeSelect.val() : 'all', e);
    if (typeof logEngagement === 'function') {
      logEngagement(window.location.href, 'editors picks', 'atb');
    }
  });
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  // JS from ImageCarousel
  var previousFocusElement = null;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-image-zoom').on('keyup', function (e) {
    var key = e.which;
    if (key == 13) {
      e.preventDefault();
      previousFocusElement = document.activeElement || document.body;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).click();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__close--btn').on('keyup', function (e) {
    var key = e.which;
    if (key == 13) {
      previousFocusElement.focus();
      previousFocusElement = null;
    }
  });

  /**
   * Custom Slick and JQuery Zoom Options for PDP Full Image View
   */
  var fullProductImageView = function fullProductImageView() {
    var startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    /* Initialize Jquery Zoom  */
    var initZoom = function initZoom($carousel) {
      var $zoomActive = $carousel.find('.slick-active');

      // Clear any existing zoom instances first
      $carousel.find('.js-pdp-image-zoom.zoom-active').each(function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).trigger('zoom.destroy');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('zoom-active');
      });

      // Initialize zoom on active slides
      $zoomActive.each(function (i, el) {
        // Set cursor to crosshair
        el.style.cursor = "crosshair";
        var $zoomContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('.js-pdp-image-zoom');
        var zoomImgUrl = $zoomContainer.data('zoom-img');
        if (zoomImgUrl && !$zoomContainer.hasClass('zoom-active')) {
          $zoomContainer.zoom({
            on: 'click-n-grab',
            // NEW: Mouse Event for settings option
            magnify: 2,
            // ONLY works when on is set to click-n-grab
            moveDirection: 'reverse',
            // Set to 'reverse' for inverted drag
            onZoomIn: function onZoomIn() {
              el.style.cursor = "grab";
            },
            onZoomOut: function onZoomOut() {
              el.style.cursor = "crosshair";
            }
          });
          $zoomContainer.addClass('zoom-active');
        }
      });
    };
    var $carousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-zoom');
    if (!$carousel.hasClass('slick-initialized')) {
      // If product has 2 prod-imgs, show both imgs in zoomCarousel when 2nd prod-img is clicked
      var slidesToShow = 2;
      var slideCount = $carousel.find('.js-pdp-image-zoom').length;
      var initialSlide = slideCount > slidesToShow ? startIndex : Math.max(0, Math.min(startIndex, slideCount - slidesToShow));
      $carousel.on('init', function (event, slick) {
        initZoom($carousel);
      }).on('afterChange', function (event, slick) {
        initZoom($carousel);
      });
      $carousel.slides({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        nextArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-zoom-modal').find('.slick-next'),
        prevArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-zoom-modal').find('.slick-prev'),
        draggable: false,
        // Helps w/ click drag functionality
        initialSlide: initialSlide
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pdp__image').removeClass('u-hide');
    }
  };

  // Conditional markup for 2 Column Carousel
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pdp__main-slideshow').hasClass('js-pdp-slides')) {
    var loadMainZoomModal = function loadMainZoomModal(returnFocus, slickIndex) {
      var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pdp__main-slideshow').data('code'),
        url: window.location.href
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: '/fw/content/product/mainZoomModal',
        triggerOpen: true,
        type: 'full',
        data: data,
        cache: true,
        returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(returnFocus),
        // The button is display:none'd while the modal is open (focusout hides it),
        // and a hidden element can't receive focus. Re-show it before the modal
        // returns focus to it on close.
        onClose: function onClose() {
          return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-zoom__btn').off('transitionend').show().addClass('product-zoom__btn--active');
        },
        onComplete: function onComplete() {
          return fullProductImageView(slickIndex);
        }
      });
    };
    // This block of code ensures that the modal doesn't open when a user is swiping through slick carousel.
    // A dragging flag was added and also a flag was added, "wasInitialMouseDownOnEl", to ensure that the modal
    // only opens if the initial mouse down and mouse up were done on the same $el element.
    var isDragging = false;
    var wasInitialMouseDownOnEl = false;
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-slick');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('mousedown.modal', function (evt) {
      isDragging = false;
      wasInitialMouseDownOnEl = false;

      // Mousedown was done initially on the el
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).closest(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-slick')).length > 0) {
        wasInitialMouseDownOnEl = true;
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('mousemove.modal', function () {
        isDragging = true;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off("mousemove.modal");
      });
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-slick').on('mouseup', function (e) {
      var $li = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).closest('.slick-slide');
      var slickIndex = $li.data('slick-index');
      // Find the leftmost visible slide in the current view
      // Check if there's a slide to the left that's also visible
      var $leftSibling = $li.prev('.slick-slide:not(.slick-cloned)').filter('.slick-active');
      var adjustedIndex = $leftSibling.length ? $leftSibling.data('slick-index') : slickIndex;
      if (!isDragging && wasInitialMouseDownOnEl) {
        e.preventDefault();
        loadMainZoomModal(previousFocusElement, adjustedIndex);
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-slick').on('keyup', function (evt) {
      var enterKey = evt.keyCode === 13;
      // The zoom button is inside the carousel and has its own click
      // handler that also fires on Enter; bail out here so the modal
      // doesn't open twice.
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).closest('.product-zoom__btn').length) {
        return;
      }
      var $li = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).closest('.slick-slide');
      var slickIndex = $li.data('slick-index');
      // Find the leftmost visible slide in the current view
      var $leftSibling = $li.prev('.slick-slide:not(.slick-cloned)').filter('.slick-active');
      var adjustedIndex = $leftSibling.length ? $leftSibling.data('slick-index') : slickIndex;
      if (enterKey) {
        loadMainZoomModal(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target), adjustedIndex);
      }
    });

    // "click to zoom" button opens the same zoom modal, starting on the
    // currently-active slide and returning focus to the button on close.
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-zoom__btn').on('click', function (e) {
      e.preventDefault();
      var slickIndex = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-slick .slick-active').first().data('slick-index') || 0;
      loadMainZoomModal(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), slickIndex);
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-image-zoom').click(function (e) {
      e.preventDefault();
      console.log(e.target);
      var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pdp__main-slideshow').data('code'),
        url: window.location.href
      });
      var $li = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).closest('.slick-slide, li'); /* UX-20577 - add li */
      var slickIndex = $li.data('slick-index');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: '/fw/content/product/mainZoomModal',
        triggerOpen: true,
        type: 'full',
        data: data,
        cache: true,
        triggerElement: previousFocusElement,
        onComplete: function onComplete() {
          return fullProductImageView(slickIndex);
        }
      });
    });
  }

  // Two image PDP Carousel
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-slides').slides({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: true,
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-dots'),
    customPaging: __WEBPACK_IMPORTED_MODULE_8__styleguide_src_assets_modules_slick_custom_paging__["a" /* default */],
    waitForAnimate: false,
    dotsClass: "image-carousel__dots",
    nextArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-slides').find('.slick-next'),
    prevArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-slides').find('.slick-prev'),
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 1
      }
    }],
    showZoomTab: true
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-special-order-request').on('click', function () {
    var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('url');
    if (url) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: url,
        triggerOpen: true,
        type: 'small',
        onComplete: function onComplete() {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-tabs").tabs();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.modal__content').find('[data-tab-content=".so-content"]').click();
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_bis_and_so__["a" /* default */])();
        }
      });
    } else {
      console.log('Missing URL for special order');
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-oos-similar').slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [{
      breakpoint: 834,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#back-in-stock').length) {
    // OOS PDP redesign AB test with exposed Notify Me form
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_bis_and_so__["a" /* default */])();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-swatch').on('click', function () {
    var url = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('swatch-url');
    var sizeEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="size-options"]:checked');
    if (sizeEl) {
      var sizeLabel = sizeEl.data('sizeLabel');
      if (sizeLabel && sizeLabel.length > 0) {
        url = removeParamFromURL(url, "size");
        url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
          size: sizeLabel
        });
      }
    }
    window.location.href = url;
  });
  function removeParamFromURL(path, param) {
    path = path.replace(new RegExp("[&]+" + param + "=[^&\\b]*", "g"), '');
    path = path.replace(/\?&+/, '?');
    return path.replace(new RegExp("&{2,}", "g"), '&');
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#lazy-styled-with").lazyAjax({
    afterLoad: function afterLoad() {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#pdp-ctl").length) {
        var tabToClick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-info-tabs');
        var tabToActivate = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-details');
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#style-with-tab").length) {
          tabToActivate = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-styled-with');
          tabToClick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#style-with-tab');
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-info-tabs').show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-tabs').tabs();
        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(".pdp.pdp--oos").length) {
          tabToActivate.addClass('tabs__content--active');
          tabToClick.click();
        } else {
          tabToClick.one('click', function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-carousel-ctl").slick('refresh');
          });
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-carousel-ctl").slick({
          dots: true,
          customPaging: __WEBPACK_IMPORTED_MODULE_8__styleguide_src_assets_modules_slick_custom_paging__["a" /* default */],
          dotsClass: "image-carousel__dots",
          appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container"),
          lazyLoad: "ondemand",
          slidesToShow: 2,
          slidesToScroll: 2,
          accessibility: true
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-ctl').on('beforeChange', function () {
          // removes dynamic content added in afterChange event
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.current-element').remove();
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-ctl').on('afterChange', function () {
          // adds copy to content in custom paging to trigger aria-live assertive
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.image-carousel__dots .slick-active .u-screen-reader').append('<span class="current-element">currently selected</span>');
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-styled-with').remove();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#style-with-tab').closest('li').remove();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#beauty-style-with').remove();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-info-tabs').show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-tabs').tabs();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-details-tab').click();
      }
    }
  });
  var $recommended = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-recommended');
  $recommended.lazyAjax({
    afterLoad: function afterLoad() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#ymal-exp-slidedown.js-slidedown').slidedown();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal').toggleReveal();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy();
    }
  });
  var $moreFromBrand = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-more-from-brand');
  $moreFromBrand.lazyAjax({
    afterLoad: function afterLoad() {
      if ($moreFromBrand && $moreFromBrand.html().trim() === '') {
        $moreFromBrand.remove(); // remove if no response since there's a min-height
      } else {
        // The reserved min-height is sized for the taller YMAL grid; the carousel is a single row.
        $moreFromBrand.css('min-height', 0);
        $moreFromBrand.find('.js-carousel--more-from-brand').each(function () {
          var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
          $this.slickSlider({
            lazyLoad: 'progressive',
            slidesToShow: 5,
            slidesToScroll: 5,
            nextArrow: $this.children('.slick-next'),
            prevArrow: $this.children('.slick-prev'),
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            }]
          });
        });
      }
    }
  });
  var $recentlyViewed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-recently-viewed');
  $recentlyViewed.lazyAjax({
    afterLoad: function afterLoad() {
      if ($recentlyViewed && $recentlyViewed.html().trim() === '') {
        $recentlyViewed.remove(); // remove if no response since there's a min-height
      } else {
        //bind events here
        var recentlyViewedCookieName = "recentlyViewedItems";
        var recentlyViewedCookieValue = __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.get(recentlyViewedCookieName);
        var recentlyViewedItems = $recentlyViewed.find('.gc').length;
        if (recentlyViewedCookieValue != 10) {
          __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.set(recentlyViewedCookieName, recentlyViewedItems, {
            expires: 14
          });
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-plp-lazy-img").lazy({
          bind: "event",
          effect: "show",
          effectTime: 0,
          threshold: 900,
          throttle: 30
        });
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-editor-pick').lazyAjax({
    afterLoad: function afterLoad() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-editor-list-carousel').each(function (i, item) {
        var $item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item);
        $item.slickSlider({
          slidesToShow: 4,
          slidesToScroll: 4,
          nextArrow: $item.find('.js-slick-next'),
          prevArrow: $item.find('.js-slick-prev')
        });
      });
      bindEditorPickEvent();
    }
  });
  var $personalizedRecsContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#lazy-recommended-for-you');
  $personalizedRecsContainer.lazyAjax({
    afterLoad: function afterLoad() {
      if ($personalizedRecsContainer && $personalizedRecsContainer.html().trim() === '') {
        $personalizedRecsContainer.remove(); // remove if no response since there's a min-height
      } else {
        //Initialization for carousels - AB Test 765
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--seven').each(function () {
          var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
          $this.slickSlider({
            lazyLoad: 'progressive',
            slidesToShow: 5,
            slidesToScroll: 5,
            nextArrow: $this.children('.slick-next'),
            prevArrow: $this.children('.slick-prev'),
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            }]
          });
        });
        // End of code for AB Test 765
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").click(function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    showSizeGuidePopup();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link2").click(function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    showSizeGuidePopup();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#bis-and-so-trigger, #bis-button, #instock-notify").click(function (event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;
    showBisPopup(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
  });
  __WEBPACK_IMPORTED_MODULE_3_modules_wishlist__["a" /* default */].bindPDPWishListEvent();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn--add-to-bag').click(function (e) {
    var selectedLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pdp__size-btn input:checked').siblings('label[aria-disabled="true"]');
    if (selectedLabel.length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').data('select-unavailable-error-text'));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').addClass("u-error");
      e.preventDefault();
      return;
    }
    e.preventDefault();
    var code = window.rcProps.pdp.code;
    if (!code) return;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-sizes input:checked').length == 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').html(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').data('select-error-text'));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').addClass("u-error");
      return '';
    }
    var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-sizes input:checked').val();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__add_to_bag__["a" /* default */])(code, size, e);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-sizes input').change(function () {
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var href = el.attr('data-href');
    if (href) {
      return;
    }
    var oneLeft = el.data('oneLeft');
    var finalSale = el.data('finalSale');
    var allSizeFinalSale = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-all-final-sale:visible').length > 0;
    var isPreorder = el.data('preorder');
    var defectiveDisclaimer = el.data('defect-disclaimer');
    var estDeliveryDate = el.data('delivery-date');
    var sizeLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label');
    var oneSize = el.val() === 'all';
    var showEstDeliveryDate = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-delivery-date').data('show-delivery') || isPreorder;
    sizeLabel.removeClass("u-color--grey");
    sizeLabel.html(el.data('size-label'));
    var addToBagBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.btn--add-to-bag');
    var estimatedText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-est-text');
    if (isPreorder) {
      sizeLabel.html(el.data('size-label') + " " + sizeLabel.data('preorder'));
      addToBagBtn.attr('aria-label', addToBagBtn.data('aria-label-preorder'));
      addToBagBtn.html(addToBagBtn.data('preorder-text'));
      estimatedText.html(sizeLabel.data('estimated-instock-text'));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.preorder-msg').show();
    } else {
      addToBagBtn.attr('aria-label', addToBagBtn.data('aria-label-atb'));
      addToBagBtn.html(addToBagBtn.data('add-to-bag-text'));
      estimatedText.html(sizeLabel.data('estimated-delivery-text'));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.preorder-msg').hide();
    }
    if (showEstDeliveryDate) {
      if (estDeliveryDate) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-est-date').html(estDeliveryDate);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-delivery-date').show();
      } else {
        var defaultDeliveryDate = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-delivery-date').data('default-est-date');
        if (defaultDeliveryDate !== '') {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-est-date').html(defaultDeliveryDate);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-delivery-date').show();
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-delivery-date').hide();
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-delivery-date').hide();
    }
    var defectiveDiv = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#final-sale-copy-defective');
    if (defectiveDisclaimer) {
      defectiveDiv.html(defectiveDisclaimer).show();
    } else {
      defectiveDiv.html('').hide();
    }
    if (finalSale) {
      if (!allSizeFinalSale) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').removeClass("u-error");
        sizeLabel.html(el.data('size-label') + " <span class='u-error'>" + sizeLabel.data('final-sale') + "</span>");
      }
      if (defectiveDisclaimer === '') {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#final-sale-copy').show();
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#final-sale-copy').hide();
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').removeClass("u-error");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#final-sale-copy').hide();
    }
    if (oneLeft) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-selection-label').removeClass("u-error");
      if (isPreorder || finalSale && !allSizeFinalSale && !oneSize) {
        sizeLabel.html(sizeLabel.html() + " <span class='u-error' aria-live='polite'>" + sizeLabel.data('one-left') + "</span>");
      } else {
        sizeLabel.html(el.data('size-label') + " <span class='u-error' aria-live='polite'>" + sizeLabel.data('one-left') + "</span>");
      }
    }
    var onSale = el.data('price') !== el.data('regularPrice');
    var priceMarkup;
    var retailValueElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-div').find('.js-retail-value');
    var retailValueMarkup = retailValueElement.length > 0 ? retailValueElement[0].outerHTML : ''; // https://stackoverflow.com/a/6459448
    if (onSale) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-div').find('.price__sale').length > 0 || __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-div').find('.out-of-stock').length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-div').find('.price__sale').html(el.data('price-formatted'));
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-div').find('.price__retail').html(el.data('regular-price-formatted'));
      } else {
        priceMarkup = '<div class="price price--lg price--on-sale"><span class="price__sale u-margin-r--md">' + el.data('price-formatted') + '</span>' + '<span class="price__retail"><span class="u-screen-reader">Previous price:</span>' + el.data('regular-price-formatted') + '</span>' + retailValueMarkup + '</div>';
      }
    } else {
      priceMarkup = '<div class="price price--lg"><span class="price__retail">' + el.data('price-formatted') + '</span>' + retailValueMarkup + '</div>';
    }
    if (priceMarkup) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-price-div').html(priceMarkup);
    }
    var afterPaySizes = document.getElementsByClassName('afterPayMsgBox');
    if (afterPaySizes.length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.afterPayMsgBox').hide();
    }
    var sizeStr = getHTMLJSSaveId(el.val());
    var afterPayElement = document.getElementById("afterPayBox" + sizeStr);
    if (afterPayElement) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.afterPayBoxMsg').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#afterPayBox' + sizeStr).show(); // show one if exists
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', '.js-bis-and-so-link', function (e) {
    e.preventDefault();
    var link = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: link,
      triggerOpen: true,
      triggerElement: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this),
      type: 'small',
      onComplete: __WEBPACK_IMPORTED_MODULE_1__modules_bis_and_so__["a" /* default */]
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-color input').change(function () {
    var href = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-href');
    if (href !== '') {
      location.href = href;
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-sizes input:checked').trigger('change');
  if (window.rcProps) {
    window.rcProps.ReCAPTCHACallBack = function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".btn--add-to-bag").click();
    };
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__modules_social_proof__["a" /* renderPdpSocialProof */])(window.rcProps.pdp.code);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_psykhe__["b" /* trackPsykhePdpView */])(window.rcProps.pdp.code, window.rcProps.pdp.productName, window.rcProps.pdp.price, window.rcProps.pdp.currency);
});

// Zoom Modal 2 Slide Desktop
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-pdp-image-zoom--ab').on('click keydown', function (e) {
  if (e.type === 'click' || e.type === 'keydown' && e.which === 13) {
    console.log('keydown');
    e.preventDefault();
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      code: '$p.code',
      url: window.location.href
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/ns/fw/2024/04_april/UX-16809/pdp-2-modal.html',
      triggerOpen: true,
      type: 'full',
      data: data,
      cache: true,
      onPrepend: function onPrepend() {
        var options = {
          lazyLoad: 'progressive',
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [{
            breakpoint: 1190,
            settings: {
              slidesToShow: 1
            }
          }],
          nextArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-zoom-modal').find('.slick-next'),
          prevArrow: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#pdp-zoom-modal').find('.slick-prev')
        };
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-zoom').slides(options);
      }
    });
  }
});

// (Mostly) from shoppingbag/index.js
// Will refactor in follow-up ticket
window.loadForwardMultipleQuickViewPdp = function (event, codes, sbsrc) {
  var requestURL = window.location.href;
  var isMens = window.location.href.indexOf('d=Mens') != -1;
  var dParam = isMens ? 'Mens' : 'Womens';
  var paramObj = {
    codes: codes,
    d: dParam,
    requestUrl: requestURL
  };
  if (sbsrc) {
    paramObj.sbsrc = sbsrc;
  }
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(paramObj);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: "/fw/ajax/multiItemQuickview.jsp",
    data: data,
    triggerOpen: true,
    returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.currentTarget),
    onComplete: function onComplete() {
      /*
      quickViewDisplayCallBack(carouselType, $triggerTarget);
       */
    }
  });
};

/***/ })

},[198]);


// WEBPACK FOOTER //
// dist/pdp.js